import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../constants/FieldsConst';
import { validMessage } from '../../../constants/ValidsFormConst';
import { dateformat } from '../../../helpers';
import { useNotification } from '../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../widgets';
import { FechaField } from '../../accesos/components/FechaField';
import ColorPalette from '../../control_estudios/horarios/components/ColorPalette';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { deleteEventosAction, saveEventosAction } from '../EventosAction';

const FormEventos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const eventosStore = Redux.useSelector((state) => state.eventos);

  const [isColor, setIsColor] = React.useState(false);

  const activo = eventosStore.activo;

  const initData = {
    nombre: '',
    publico: false,
    desc: '',
    inicio: null,
    inicioHora: '00:00',
    fin: null,
    finHora: '23:59',
    color: '#1565C0',
    idEntidad: entidadesStore.activo.id,
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    inicio: false,
    fin: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (eventosStore.slotInfo) {
      const endDate = new Date(eventosStore.slotInfo.end);
      endDate.setDate(endDate.getDate() - 1);

      const inicio = dateformat(eventosStore.slotInfo.start, {});
      const fin = dateformat(endDate, {});

      setData({
        ...data,
        ...activo,
        inicio,
        inicioHora: dateformat(eventosStore.slotInfo.start, { isHHmm: true }),
        fin,
        finHora:
          inicio === fin
            ? '23:00'
            : dateformat(eventosStore.slotInfo.end, { isHHmm: true }),
        idEstatus: activo?.estatus.id ?? 1,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          inicio: dateformat(activo.inicio, {}),
          inicioHora: dateformat(activo.inicio, { isHHmm: true }),
          fin: dateformat(activo.fin, {}),
          finHora: dateformat(activo.fin, { isHHmm: true }),
          publico: activo?.public ?? false,
          idEstatus: activo?.estatus.id ?? 1,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      const { desc, nombre, publico, idEstatus, color } = data;

      const inicio = dateformat(`${data.inicio} ${data.inicioHora}`, {
        full: true,
      });
      const fin = dateformat(`${data.fin} ${data.finHora}`, { full: true });

      let res = await saveEventosAction(
        { dispatch, notify },
        activo?.id,
        {
          nombre,
          inicio,
          fin,
          desc,
          public: publico,
          color,
          idEstatus,
          idEntidad: loginStore.isAdminTeacher
            ? null
            : entidadesStore.activo.id,
        },
        eventosStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(CONST.nombre.name, e.target.value)
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FechaField
            label="Fecha de inicio"
            botonCurrentDate={false}
            value={data.inicio}
            onChange={(e) => {
              if (!isNaN(e)) {
                _handleSetDataField(CONST.inicio.name, dateformat(e, {}));
              }
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="time"
            label={CONST.inicioHora.label}
            value={data.inicioHora}
            onChange={(e) =>
              _handleSetDataField(CONST.inicioHora.name, e.target.value)
            }
            id={CONST.inicioHora.name}
            InputProps={{
              inputProps: { min: 1 },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FechaField
            label="Fecha final"
            value={data.fin}
            botonCurrentDate={false}
            onChange={(e) => {
              if (!isNaN(e)) {
                _handleSetDataField(CONST.fin.name, dateformat(e, {}));
              }
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="time"
            label={CONST.finHora.label}
            value={data.finHora.toString()}
            onChange={(e) =>
              _handleSetDataField(CONST.finHora.name, e.target.value)
            }
            id={CONST.finHora.name}
            InputProps={{
              inputProps: { min: 1 },
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={data.publico}
                onChange={(e) =>
                  _handleSetDataField(CONST.publico.name, e.target.checked)
                }
              />
            }
            label={CONST.publico.label}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack direction="row" spacing={1}>
            <TextField
              fullWidth
              size="small"
              id={CONST.color.name}
              required
              label={CONST.color.label}
              value={data.color}
              maxLength
              onChange={(e) => {
                if (!e.target.value || e.target.value === '') {
                  return _handleSetDataField(CONST.color.name, '#1565C0');
                }
                _handleSetDataField(CONST.color.name, e.target.value);
              }}
              helperText={dataError.color ? validMessage.required : null}
              error={dataError.color}
              inputProps={{ maxLength: 7 }}
            />
            <Box
              sx={{
                backgroundColor: data.color ?? '#1565C0',
                width: 40,
                height: 40,
                borderRadius: 2,
                color: 'white',
                fontWeight: 'bold',
                fontSize: 18,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover': {
                  cursor: 'pointer',
                  border: '2px solid black',
                },
              }}
              onClick={() => setIsColor(!isColor)}
            >
              {isColor ? 'X' : 'C'}
            </Box>
          </Stack>
          {isColor && (
            <ColorPalette
              value={data.color ?? '#1565C0'}
              getColor={(color) => {
                _handleSetDataField(CONST.color.name, color);
              }}
            />
          )}
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={2}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="center"
          >
            <BotonComponent
              click={_handleSubmit}
              text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
              disabled={loadingSave}
              green={!activo}
              blue={activo}
              saveIcon
            />
            {eventosStore.activo && (
              <BotonComponent
                click={async () => {
                  setLoadingSave(true);
                  await deleteEventosAction(
                    { dispatch, notify },
                    eventosStore.activo.id,
                    eventosStore.params,
                  );
                  setLoadingSave(false);
                  setOpenModalForm(false);
                  // setActivoPtemEvaluacionesAction(dispatch, el);
                  // setDetallesPlanEvaluacionAction(
                  //   dispatch,
                  //   'deleteEvaluacion',
                  //   true,
                  // );
                  // setActivoPlanevaTemasAction(dispatch, null);
                  // setActivoPevaActividadesAction(dispatch, null);
                }}
                red
                text="ELIMINAR"
                deleteIcon
              />
            )}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormEventos;
